/* import __COLOCATED_TEMPLATE__ from './tax-form.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-tax-form';

class TaxForm extends Component {
  @service session;

  @tracked forceDisplayIframe = false;

  get baseClassName() {
    return CLASS_NAME;
  }

  get classNames() {
    const extraClasses = [];

    return clsx(
      this.args.class,
      this.baseClassName,
      ...extraClasses,
    );
  }

  get detailText() {
    if (this.session.currentUser.taxInformationComplete) {
      return "You're good to go! Click edit to review or revise your information.";
    }

    switch (this.session.currentUser.taxFormBaseStatus) {
      case 'SUBMITTED':
        return "We are verifying your information. No additional action is needed at this time, thanks!";
      case 'NOT_SUBMITTED':
      default:
        return 'You must submit your information in order for us to create your tax documentation.';
      case 'PENDING_REVIEW':
        return 'You have submitted your information, and it is under review. We will contact you if further action is required on your part.';
    }
  }

  get displayIframe() {
    return this.args.displayIframe || this.forceDisplayIframe;
  }

  get statusText() {
    switch (this.session.currentUser.taxFormBaseStatus) {
      case 'SUBMITTED':
        return 'COMPLETE';
      case 'NOT_SUBMITTED':
      default:
        return 'INCOMPLETE';
      case 'PENDING_REVIEW':
        return 'PENDING REVIEW';
    }
  }

  get statusColor() {
    switch (this.session.currentUser.taxFormBaseStatus) {
      case 'SUBMITTED':
        return 'lsg-green';
      case 'NOT_SUBMITTED':
      default:
        return 'lsg-red';
      case 'PENDING_REVIEW':
        return 'lsg-yellow';
    }
  }

  @action
  toggleForceDisplayIframe() {
    this.forceDisplayIframe = !this.forceDisplayIframe;
  }
}

export default TaxForm;
